import React, { Component } from "react"

import Stack from "@mui/material/Stack"
import { CCard, CCardBody, CCardTitle } from "@coreui/react"
import { Divider } from "@mui/material"
import Typography from "@mui/material/Typography"
import SportsCricketIcon from "@mui/icons-material/SportsCricket"
import RadarIcon from "@mui/icons-material/Radar"
import ScubaDivingIcon from "@mui/icons-material/ScubaDiving"
import GroupsIcon from "@mui/icons-material/Groups"

export class UserHockeyData extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		return (
			<CCard>
				<CCardBody>
					<CCardTitle>Hockey</CCardTitle>
					<Stack direction="row" spacing={2}>
						<GroupsIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Club: {this.props.club}
						</Typography>
					</Stack>
					<Divider>Equipo</Divider>
					<Stack direction="row" spacing={2}>
						<RadarIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Posición: {this.props.position}
						</Typography>
					</Stack>
					<Stack direction="row" spacing={2}>
						<ScubaDivingIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Aletas: {this.props.aletas}
						</Typography>
					</Stack>
					<Stack direction="row" spacing={2}>
						<SportsCricketIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Stick: {this.props.stick}
						</Typography>
					</Stack>
				</CCardBody>
			</CCard>
		)
	}
}

export default UserHockeyData
